export const POST_FUEL_CONSUMPTION_REPORT_PER_BUS = 'POST_FUEL_CONSUMPTION_REPORT_PER_BUS';
export const CLEAR_FUEL_CONSUMPTION_REPORT_PER_BUS = 'CLEAR_FUEL_CONSUMPTION_REPORT_PER_BUS';
export const FLAG_FUEL_CONSUMPTION_REPORT_PER_BUS_ACTIVITY =
    'FLAG_FUEL_CONSUMPTION_REPORT_PER_BUS_ACTIVITY';